import { InjectionToken } from '@angular/core';

import { IGiftProvider } from '../entities/transactions';

export const GIFT_PROVIDERS_TOKEN = new InjectionToken<IGiftProvider[]>('GIFT_PROVIDERS');
